import { request, requestApiOk } from './client';
import type { TenantNotification } from '@/generated/ts-rs/TenantNotification';
import type { NotificationCategory } from '@/generated/ts-rs/NotificationCategory';
import type { NotificationLevel } from '@/generated/ts-rs/NotificationLevel';
import type { NotificationListResponse } from '@/generated/ts-rs/NotificationListResponse';
import type { UnreadCountResponse } from '@/generated/ts-rs/UnreadCountResponse';

export type { TenantNotification, NotificationCategory, NotificationLevel, NotificationListResponse, UnreadCountResponse };

export function fetchNotifications(
  token: string,
  params: {
    page?: number;
    limit?: number;
    category?: NotificationCategory;
  } = {},
): Promise<NotificationListResponse> {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.set('offset', String((params.page - 1) * (params.limit || 20)));
  if (params.limit) queryParams.set('limit', String(params.limit));
  if (params.category) queryParams.set('category', params.category);

  const query = queryParams.toString();
  return request('GET', `/api/tenant/notifications${query ? `?${query}` : ''}`, undefined, token);
}

export function fetchUnreadCount(token: string): Promise<number> {
  return request<UnreadCountResponse>('GET', '/api/tenant/notifications/unread-count', undefined, token).then(
    (res) => res.count,
  );
}

export function markAsRead(token: string, notificationId: string): Promise<void> {
  return requestApiOk<void>('POST', `/api/tenant/notifications/${notificationId}/read`, undefined, token);
}

export function markAllAsRead(token: string): Promise<void> {
  return requestApiOk<void>('POST', '/api/tenant/notifications/read-all', undefined, token);
}

export function deleteNotification(token: string, notificationId: string): Promise<void> {
  return requestApiOk<void>('DELETE', `/api/tenant/notifications/${notificationId}`, undefined, token);
}
